export default __webpack_public_path__ + "static/media/kidprofile.e54586d0b1b79cef43bd81573d4551b9.png";